import React from 'react';
import './GovernanceSwitch.css';

export default function GovernanceSwitch({ value = 'board', onChange }) {
  const sole = value === 'soleAdministrator';
  return <div className="governance-switch">
    <button type="button" className={`governance-switch-label${!sole ? ' is-selected' : ''}`} onClick={() => onChange('board')}>Consejo/Junta</button>
    <button type="button" role="switch" aria-label="Administrador único" aria-checked={sole} className="governance-switch-track" onClick={() => onChange(sole ? 'board' : 'soleAdministrator')}><span /></button>
    <button type="button" className={`governance-switch-label${sole ? ' is-selected' : ''}`} onClick={() => onChange('soleAdministrator')}>Administrador único</button>
  </div>;
}
